<template>
  <div>
    <mf-button label="Importar grupo" @click="importDialog = true" />
    <import-dynamic-csv
      v-model="importDialog"
      title="Importar grupos"
      import-label="Importar lista de grupos"
      :required-all-of="requiredFields"
      :fields="importFields"
      :boolean-configuration-options="importConfigurationOptions"
      :listText="textList"
      :logicText="conditionText"
      :customFields="true"
      :customFieldsWithDisabled="fieldsWithDisabled"
    >
      <template v-slot:custom-text>
        <p class="texto-corrido"></p>
      </template>
    </import-dynamic-csv>
    <conferir-importacao-grupos
      v-model="checkDialog"
      :actions="actions"
      :failures="failures"
      :dataFileUrl="dataFileUrl"
      :updatePreexisting="updatePreexisting"
      :loadingData="loading"
      @resetSettings="cleanFields"
    />
  </div>
</template>

<script>
import { REQUEST_PRODUCTS_GROUPS_BULK_UPSET } from '../../graphql'

export default {
  components: {
    ImportDynamicCsv: () => import('@/components/ImportDynamicCsv.vue'),
    ConferirImportacaoGrupos: () => import('@/modules/produtos/gerenciamento-produtos/views/pages/ConferirImportacaoGrupos.vue'),
  },
  provide: function () {
    return {
      objectSelected: this.bulkUploadGroups,
      updateRequiredColumns: this.updateRequiredColumns,
    }
  },
  data: () => ({
    importDialog: false,
    checkDialog: false,
    loading: false,
    updatePreexisting: false,
    totalNumberOfLines: 0,
    dataFileUrl: '',
    conditionText: 'e',
    textList: 'É necessário informar no mínimo um identificador único de produto (SKU ou EAN) e o nome do grupo ao qual ele pertence:',
    failures: {},
    actions: [],
    requiredFields: [],
    selectedColumns: [],
  }),
  computed: {
    importFields() {
      return [
        { text: 'SKU (ID)', value: 'sku' },
        { text: 'EAN', value: 'ean' },
        { text: 'Nome do grupo', value: 'name' },
      ]
    },
    importConfigurationOptions() {
      return [
        {
          label: 'Atualizar grupos pré-existentes',
          value: 'update_preexisting',
          tooltip:
            'Se ativa, essa função atualiza as informações que já existem na plataforma e estão diferentes do que você importar agora, inserindo produtos em grupos já existentes.',
        },
      ]
    },
    fieldsWithDisabled() {
      return this.importFields.map((obj) => {
        let disabled = false

        if (Boolean(this.selectedColumns.includes('name')) && this.selectedColumns.length === 2) {
          disabled = true
        } else if ((this.selectedColumns.includes('sku') || this.selectedColumns.includes('ean')) && obj.value !== 'name') {
          disabled = true
        } else {
          disabled = Boolean(this.selectedColumns.includes(obj.value))
        }

        return { ...obj, disabled }
      })
    },
  },
  methods: {
    updateRequiredColumns(selectedColumns) {
      const filterColumns = selectedColumns.filter((column) => !!column)
      this.selectedColumns = filterColumns
      if (!filterColumns.length || (filterColumns.includes('name') && filterColumns.length === 1)) {
        this.requiredFields = ['name', 'ean', 'sku']
        this.conditionText = 'ou'
      } else if (filterColumns.includes('name')) {
        this.requiredFields = filterColumns
        this.conditionText = 'e'
      } else {
        this.requiredFields = ['name'].concat(filterColumns)
        this.conditionText = 'e'
      }
    },
    bulkUploadGroups({ file, selectedColumns, booleanConfigurationOptionsValues: { update_preexisting } }) {
      try {
        this.loading = true
        this.$apollo
          .mutate({
            mutation: REQUEST_PRODUCTS_GROUPS_BULK_UPSET,
            variables: {
              file,
              updatePreexisting: update_preexisting,
              columns: selectedColumns.reduce((acc, column, index) => (column ? { ...acc, [column]: index } : acc), {}),
            },
            context: {
              uri: this.$microservicesUrls['upload'],
            },
          })
          .then(({ data: { requestProductsGroupsBulkUpsert } }) => {
            const {
              dataFileURL,
              actionsPreview: { groupsToUpdate, groupsToCreate },
              ...failures
            } = requestProductsGroupsBulkUpsert

            this.updatePreexisting = update_preexisting
            this.failures = failures
            this.dataFileUrl = dataFileURL || ''
            this.actions = [
              {
                action: 'Grupos que serão criados',
                quantity: groupsToCreate,
              },
              {
                action: 'Grupos que serão editados',
                quantity: groupsToUpdate,
              },
            ]
            this.checkDialog = true
            this.loading = false
          })
      } catch (e) {
        console.log(e)
        this.$snackbar({ message: 'Falha ao importar arquivo de grupos.' })
      }
    },
    cleanFields() {
      this.updatePreexisting = false
      this.failures = {}
      this.dataFileUrl = ''
      this.actions = []
    },
  },
}
</script>
